// Boutiques du donjon
// 1 coffre + 1 potion de vie consommable (toujours) + 3-4 potions permanentes aléatoires

export const POTIONS = {
  pv: { nom: "Potion de Vie+", description: "+15 PV max permanent", stat: "pv", value: 15, icon: "❤️", couleur: "bg-rose-500" },
  atk: { nom: "Potion de Force", description: "+3 ATK permanent", stat: "atk", value: 3, icon: "⚔️", couleur: "bg-orange-500" },
  def: { nom: "Potion d'Acier", description: "+3 DEF permanent", stat: "def", value: 3, icon: "🛡️", couleur: "bg-blue-500" },
  vit: { nom: "Potion d'Agilité", description: "+4 VIT permanent", stat: "vit", value: 4, icon: "💨", couleur: "bg-emerald-500" },
  crit: { nom: "Potion du Chanceux", description: "+5% CRIT permanent", stat: "crit", value: 5, icon: "🍀", couleur: "bg-fuchsia-500" },
  precision: { nom: "Potion de Vision", description: "+5% Précision permanent", stat: "precision", value: 5, icon: "🎯", couleur: "bg-amber-500" },
  degatsElem: { nom: "Potion Élémentaire", description: "+2 Dégâts Élémentaires", stat: "degatsElem", value: 2, icon: "✨", couleur: "bg-purple-500" },
  res: { nom: "Potion Résistance", description: "+5% Résistance permanent", stat: "res", value: 5, icon: "🌀", couleur: "bg-cyan-500" },
};

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// Génère le stock d'une boutique
export const generateShop = (floor = 1, discount = 0) => {
  const priceMult = (1 + (floor - 1) * 0.3) * (1 - discount);
  // 3-4 potions permanentes aléatoires parmi les types disponibles
  const keys = shuffle(Object.keys(POTIONS));
  const count = 3 + Math.floor(Math.random() * 2); // 3 ou 4
  const potions = [];
  for (let i = 0; i < count; i++) {
    const key = keys[i];
    const p = POTIONS[key];
    potions.push({
      ...p,
      id: `${key}_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
      key,
      price: Math.round((30 + Math.random() * 20) * priceMult),
      sold: false,
    });
  }
  // 1 health potion consommable (toujours)
  const consumablePrice = Math.round((40 + Math.random() * 10) * priceMult);
  const consumable = {
    id: `health_potion_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
    itemId: "health_potion",
    nom: "Potion de Vie",
    description: "Restaure 50% de tes PV max (utilisable depuis l'inventaire).",
    icon: "🧪",
    couleur: "bg-rose-600",
    price: consumablePrice,
    sold: false,
  };
  // 1 coffre par boutique
  const chestPrice = Math.round((80 + Math.random() * 40) * priceMult);
  return {
    potions,
    consumable,
    chest: { id: `chest_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`, price: chestPrice, sold: false },
  };
};
